import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import moment from "moment";
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import {Link} from "react-router-dom";
import urldecode from "locutus/php/url/urldecode";
import {paramsSerializer, postData} from "../../utils/request";
import Icon from "../form/Icon";
import {CurrencyFormatter, EmailFormatter, PartnerSelect, UnitFormatter} from "../../utils/formatters";
import DateTimeInput from "../form/DateTimeInput";
import VoucherReportList from "./lists/VoucherReportList";
import EmailTemplateEditor from "./EmailTemplateEditor";
import connect from "react-redux/es/connect/connect";
import Select from "../form/Select";

const sortable = true;
const filterable = true;

class Filter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            from: this.props.from,
            to: this.props.to,
            partner: this.props.partner,
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        const state = {};
        if (this.props.partner !== prevProps.partner && this.state.partner === prevState.partner) {
            state.partner = this.props.partner;
        }
        if (this.props.from !== prevProps.from && this.state.from === prevState.from) {
            state.from = this.props.from;
        }
        if (this.props.to !== prevProps.to && this.state.to === prevState.to) {
            state.to = this.props.to;
        }
        if (Object.keys(state).length) {
            this.setState(state);
        }
    }

    render() {
        return (
            <div className="row">
                <div className="col-md-3">
                    <div className="form-group">
                        <Select
                            objectValue={false}
                            name="partner"
                            value={this.state.partner}
                            labelKey="name"
                            valueKey="partner_id"
                            component="partner"
                            optionsTemplate={PartnerSelect}
                            storeType="remote"
                            label="Partner"
                            saveChanges={(field, partner) => this.setState({partner})}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="form-group">
                        <DateTimeInput
                            maxDate={this.state.to}
                            value={this.state.from}
                            label="Időszak"
                            saveChanges={(field, from) => this.setState({from})}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="form-group">
                        <DateTimeInput
                            minDate={this.state.from}
                            value={this.state.to}
                            maxDate={moment().format("YYYY-MM-DD")}
                            label="&nbsp;"
                            saveChanges={(field, to) => this.setState({to})}
                        />
                    </div>
                </div>
                <div className="col-md-2">
                    <label className="control-label">&nbsp;</label>
                    <Button
                        color="primary"
                        block={true}
                        icon={{lib: "fa", name: "search"}}
                        onClick={() => {
                            this.props.onFilter({from: this.state.from, to: this.state.to, partner: this.state.partner});
                        }}
                    >
                        Szűrés
                    </Button>
                </div>
            </div>
        );
    }
}

class VoucherReportEditorGenerator extends React.Component {

    state = {
        from: moment().subtract(1, "months").startOf('month').format("YYYY-MM-DD"),
        to: moment().subtract(1, "months").endOf('month').format("YYYY-MM-DD"),
        partner: null
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        if (!this.props.pos) {
            return <Box header="Hiba" theme="danger">
                Kérlek jelentkezz be egy eladási helyre!
            </Box>;
        }
        const startdate = this.state.from + " 00:00:00";
        const enddate = this.state.to + " 23:59:59";

        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header="Riportok"
                >
                    <VoucherReportList
                        ref={(el) => this.list = el}
                        {...this.props}
                        loadForm={null}
                        filter={[
                            {field: "agent", value: this.props.pos.partner.partner_id}
                        ]}
                    />
                </List>
            <Box>
                <Filter
                    from={this.state.from}
                    to={this.state.to}
                    partner={this.state.partner}
                    onFilter={({from, to, partner}) => {
                        this.setState({from, to, partner});
                    }}
                />
                {/*this.state.partner && <SelectorGrid
                    ref={(list) => this.partnerList = list}
                    className={"p-small-table"}
                    component="Voucher"
                    pageSize={50}
                    loading={this.props.isLoading}
                    filter={[
                        {
                            filters: [
                                {
                                    filters:
                                    [
                                        {field: "used", value: [startdate, enddate], operator: "between"},
                                        {field: "used_partner", value: this.state.partner},
                                    ]
                                },
                                {
                                    filters:
                                    [
                                        {field: "sold", value: [startdate, enddate], operator: "between"},
                                        {field: "sold_partner", value: this.state.partner},
                                    ]
                                }
                            ],
                            operator: "OR"
                        },
                    ]}
                    columns={{
                        "barcode": {
                            header: 'Vonalkód',
                            width: 3,
                            sortable,
                            filterable
                        },
                        "amount": {
                            header: 'Érték',
                            width: 3,
                            renderer: CurrencyFormatter,
                            className: "currency",
                            filterable,
                            sortable
                        },
                    }}
                />*/}
                {
                    this.state.partner && <Fragment>
                        <div className="form-group">
                            <label className="control-label">Beváltás</label>
                            <SelectorGrid
                                ref={(list) => this.usedList = list}
                                className={"p-small-table"}
                                component="Voucher"
                                pageSize={50}
                                loading={this.props.isLoading}
                                filter={[
                                    {field: "used", value: [startdate, enddate], operator: "between"},
                                    {field: "used_partner", value: this.state.partner},
                                ]}
                                columns={{
                                    "used": {
                                        header: 'Dátum',
                                        width: 4,
                                        sortable,
                                        filterable
                                    },
                                    "serial_number": {
                                        header: 'Ellenőrző kód',
                                        width: 3,
                                        sortable,
                                        filterable
                                    },
                                    "amount": {
                                        header: 'Érték',
                                        width: 3,
                                        renderer: CurrencyFormatter,
                                        className: "currency",
                                        filterable,
                                        sortable
                                    },
                                }}
                                orderBy={{field: "used", direction: "DESC"}}
                            />
                        </div>
                        <div className="form-group">
                            <label className="control-label">Eladás</label>
                            <SelectorGrid
                                ref={(list) => this.soldList = list}
                                className={"p-small-table"}
                                component="Voucher"
                                pageSize={50}
                                loading={this.props.isLoading}
                                filter={[
                                    {field: "sold", value: [startdate, enddate], operator: "between"},
                                    {field: "sold_partner", value: this.state.partner},
                                ]}
                                columns={{
                                    "sold": {
                                        header: 'Dátum',
                                        width: 4,
                                        sortable,
                                        filterable
                                    },
                                    "serial_number": {
                                        header: 'Ellenőrző kód',
                                        width: 3,
                                        sortable,
                                        filterable
                                    },
                                    "amount": {
                                        header: 'Érték',
                                        width: 3,
                                        renderer: CurrencyFormatter,
                                        className: "currency",
                                        filterable,
                                        sortable
                                    },
                                }}
                                orderBy={{field: "sold", direction: "DESC"}}
                            />
                        </div>
                        <div className="form-group">
                            <Button
                                block={true}
                                color="primary"
                                icon={{lib: "fas", name: "shapes"}}
                                disabled={this.props.isLoading}
                                onClick={() => {
                                    this.props.processAction(async () => {
                                        const res = await postData({
                                            action: 'VoucherReport.create',
                                            data: {
                                                partner: this.state.partner,
                                                startdate,
                                                enddate,
                                            }
                                        });
                                        this.usedList && this.usedList.refresh();
                                        this.soldList && this.soldList.refresh();
                                        this.list && this.list.refresh();
                                        return res;
                                    });
                                }}
                            >
                                Generálás
                            </Button>
                        </div>
                    </Fragment>
                }
            </Box>
            <EmailTemplateEditor
                filter={[{field: "token", value: this.props.componentConfig.config.email_template}]}
                fieldForm={this.props.componentConfig.config.email_template}
                editorContext="VoucherReportEmailTemplate"
            />
        </Fragment>;
    }
}

export default connect((state) => {
    return {
        pos: (state.app.till || {}).pos,
    };
}, {})(createEditor({
    componentName: "VoucherReport",
    WrappedComponent: VoucherReportEditorGenerator
}));
